import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PageLayout from '@/components/Layout/PageLayout';
import CardHeader from '@/components/Card/CardHeader';
import { useGetManagedAccountPaymentsManager } from '@/api/hooks/managed-accounts/useGetManagedAccountPaymentsManager';
import PaymentsManagerConfigurationForm from './PaymentsManagerConfigurationForm';

const MANAGED_ACCOUNT_ID = 1;

const PageHeader = ({ name }) => (
  <CardHeader color='primary'>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <AccountBalanceOutlined sx={{ color: 'white', mr: 1 }} />
      <Typography
        variant='h6'
        component='h1'
        sx={{ color: 'white', fontWeight: 500 }}>
        {name ? `${name} Managed Accounts` : 'Managed Accounts'}
      </Typography>
    </Box>
  </CardHeader>
);

const ManagedAccount = () => {
  const {
    managedAccount,
    loading,
    error,
  } = useGetManagedAccountPaymentsManager(MANAGED_ACCOUNT_ID);

  return (
    <PageLayout
      height='auto'
      overflow='auto'
      header={<PageHeader name={managedAccount?.name} />}>
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress aria-label='Loading managed account' />
        </Box>
      )}

      {!loading && error && <Alert severity='error'>{error}</Alert>}

      {!loading && !error && managedAccount && (
        <Accordion expanded disableGutters variant='outlined'>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls='payments-manager-content'
            id='payments-manager-header'>
            <Typography variant='h6'>Payments Manager</Typography>
          </AccordionSummary>
          <AccordionDetails id='payments-manager-content' sx={{ py: 3 }}>
            <PaymentsManagerConfigurationForm
              managedAccountId={MANAGED_ACCOUNT_ID}
              configuration={managedAccount.configuration}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </PageLayout>
  );
};

export default ManagedAccount;
